import { VueConstructor } from 'vue'

/**
 * TODO: 命名を変更する。
 * 汎用化を意図したものと思われ、実際にも汎用的な内容ではあるが、Authという特定の文脈を引きずった名前になっている。
 * cf. https://github.com/Everforth/growthpalette-front/pull/8367#discussion_r2009036152
 */
export interface AuthErrorEvent {
  content: VueConstructor | string
  onCloseModal?: () => void
}

export const nop = () => { /* no operation */ }
